import React from 'react'

const withExtraProps = (WrappedComponent, extraProps) => props => {
  return <WrappedComponent {...props} {...extraProps} />
}

export default withExtraProps
